/* eslint-disable max-len */
const id = {
  seo: {
    // eslint-disable-next-line max-len
    keywords: 'Bstation, anime gratis, anime, anime top,BL,GL,wetv,iqyi,chunchyroll,Demon Slayer: Kimetsu no Yaiba, Attack on Titan, That Time I Got Reincarnated as a Slime (seri ke 2),Fly Me to the Moon, Mushoku Tensei: Isekai Ittara Honki Dasu,Heaven Official\'s Blessing, cosplay, SubThai',
  },
  common: {
    more: 'Lainnya',
    confirm: 'Konfirmasi',
    cancel: 'Batal',
    home: 'Home',
    clickToMove: 'Klik untuk seret',
  },
  follow: {
    follow: 'Ikuti',
    following: 'Mengikuti',
  },
  roomInfo: {
    share: 'Bagikan',
    copySucceed: 'Berhasil menyalin tautan',
    copyFailed: 'Gagal menyalin tautan',
    liveClosed: 'Live belum dimulai',
    viewer: ' Total {count} penonton',
  },
  roomVideo: {
    controlBar: {
      play: 'Putar',
      pause: 'Jeda',
      refresh: 'Segarkan',
      refreshSucceed: 'Berhasil menyegarkan',
      refreshFailed: 'Gagal menyegarkan',
      refreshing: 'Sedang menyegarkan',
      fullscreen: 'Mode layar penuh',
      exitFullscreen: 'Keluar dari layar penuh',
      switchQning: 'Resolusi sedang dialihkan ke',
      switchQnFailed: 'Pengalihan resolusi gagal, harap coba lagi',
      switchQnSucceed: 'Resolusi telah dialihkan ke',
    },
  },
  comment: {
    title: 'Danmaku',
    sender_input_placeholder: 'Kirimkan Danmaku~',
    sended_send: 'Kirim',
    new_messages: 'Perbarui {count} Danmaku',
    login_before_send: 'Login untuk berpartisipasi dalam karnaval Danmaku',
    // eslint-disable-next-line max-len
    default_welcome: 'Selamat datang di ruang siaran langsung! Kami menggiatkan konten yang inovatif dan beragam. Di saat yang sama, kami juga akan mengambil tindakan yang diperlukan untuk mencegah dan menghentikan segala bentuk pelanggaran hukum dan peraturan, persyaratan dan etika moral otoritas peraturan lokal, pelanggaran hak hukum orang lain dan segala bentuk konten apa pun yang dapat memengaruhi keselamatan dan kesehatan masyarakat agar tidak menyebar. Selain itu, pelanggaran hukum dapat dilaporkan kepada badan otoritas pengawas untuk ditangani sesuai dengan persyaratan peraturan perundang-undangan yang berlaku.'
  },
  rank: {
    title: 'Peringkat pengguna',
    login: 'Login',
    viewRank: ' dan lihatlah peringkat Anda',
    toContribute: 'Sumbangkan hadiah Star untuk naik peringkat',
    myScore: 'Nilai sumbangan',
    noData: 'Ayo duduki peringkat dan dukung host!',
  },
  gift: {
    all: 'Semua hadiah',
    topUp: 'Top up',
    top: 'Populer',
    starDesc: 'Pengguna dapat memperoleh Star melalui pembelian, properti yang ditukarkan dengan Star akan menjadi pendapatan host',
  },

  introduction: {
    title: 'Pengenalan Live',
  },
  balance: {
    insufficientTitle: 'Saldo tidak cukup',
    insufficientContent: 'Saldo Stars tidak cukup, harap top up',
    buy: 'Top up',
  },
  payment: {
    title: 'Beli Stars',
    balance: 'Saya Stars',
    next: 'Top Up',
    agree: 'Dengan mengklik tombol "Top Up", Anda telah menyetujui ',
    agreement: 'Perjanjian Top Up Stars',
    repay: 'Bayar ulang',
    getPaid: 'Saya telah membeli',
    orderTitle: 'Harap selesaikan pembayaran di halaman yang baru',
    exchangeRateDesc: 'Harga Stars dapat berubah sesuai dengan nilai tukar kurs dan metode pembayaran.',
    methodTitle: 'Pilih Metode Pembayaran',
    // eslint-disable-next-line max-len
    orderDesc: 'Harap jangan meninggalkan halaman ini sebelum selesai membayar, klik tombol di bawah sesuai kondisi Anda setelah selesai membayar',
    toast_success: 'Top up berhasil',
    toast_fail: 'Gagal top up',
    toast_notPay: 'Gagal belum selesai',
    toast_cancel: 'Top up dibatalkan',
    toast_timeout: 'Waktu top up telah kedaluwarsa',
  },

  home: {
    live: 'LIVE',
    liveNow: 'Sedang Live',
    refresh: 'Muat ulang',
    refreshFailed: 'Gagal memuat ulang. Silakan coba lagi.',
    loadMore: 'Memuat lainnya...',
    noMore: 'Tidak ada lagi konten yang lain',
    clickToLive: 'Klik untuk hidup'
  },

  userCard: {
    followers: '{count} Pengikut',
    videos: '{count} Video',
    promote: 'Jadikan admin',
    demote: 'Hapus admin ini',
    mute: 'Nonaktifkan komentar pegguna ini',
    unmute: 'Aktifkan komentar pengguna ini',
  },
  modals: {
    muteConfirm: 'Setelah dinonaktifkan, pengguna tidak bisa mengirimkan Danmaku. Apakah Anda yakin ingin menonaktifkan komentar pengguna {username}?',
    muteSuccess: 'Komenar pengguna ini telah dinonaktifkan',
    unmuteConfirm: 'Apakah Anda yakin ingin mengaktifkan komentar pengguna {username}?',
    unmuteSuccess: 'Berhasil mengaktifkan',
    promoteConfirm: 'Apakah Anda yakin ingin menjadikan pengguna {username} menjadi admin dari ruangan siaran langsung ini?',
    promoteSuccess: '{username} telah dijadikan admin oleh penyelenggara',
    demoteConfirm: 'Apakah Anda yakin ingin menghapus pengguna {username} dari admin ruangan siaran ini?',
    demoteSuccess: 'Berhasil menghapus admin',
  },
  chargeStrip: {
    tabProgress: 'Total Charging',
    consumeStar: 'Gunakan Star atau selesaikan tugas untuk mendapatkan poin energi agar bisa ikutan dalam undian isi energi.',
    // eslint-disable-next-line max-len
    consumeReward: 'Setiap Anda menggunakan 1 Star di dalam live streaming, energi live streaming tersebut dan total isi energi akan bertambah 1 poin.',
    followRoom: 'Ikuti live streaming',
    followRoomAward: 'Energi live streaming yang diikuti dan total isi energi akan bertambah 3 poin.',
    sendDanmaku: 'Kirim 1 Danmaku di live streaming hari ini',
    sendDanmakuAward: 'Energi live streaming  yang dikirimkan Danmaku dan total isi energi akan bertambah 1 poin.',
    watchLive10M: 'Nonton satu live streaming yang sama selama 10 menit',
    watchLive10MAward: 'Energi live streaming  yang ditonton dan total isi energi akan bertambah 1 poin.',
    watchLive30M: 'Nonton satu live streaming yang sama selama 30 menit',
    watchLive30MAward: 'Energi live streaming yang ditonton dan total isi energi akan bertambah 3 poin.',
    watchLive120M: 'Nonton satu live streaming yang sama selama 120 menit',
    watchLive120MAward: 'Energi live streaming yang ditonton dan total isi energi akan bertambah 15 poin.',
    watchLive: 'Nonton satu live streaming yang sama selama 10/30/120 menit',
    watchLiveAward: 'Energi live streaming  yang ditonton dan total isi energi akan bertambah 1/3/15 poin.',

    tabTask: 'Charging Tasks',
    uAddRoomEnergy: 'Jumlah isi energi Anda pada live streaming ini adalah:',
    uAddStationEnerygy: 'Total isi energi Anda secara keseluruhan adalah:',
    // eslint-disable-next-line max-len
    consumeStarInRoom: 'Setiap Anda menggunakan 1 Star di dalam live streaming ini, energi live streaming ini dan total isi energi akan bertambah 1 poin.',

    tabRule: 'Rules',
    ruleDesc: 'Gunakan Star/selesaikan tugas pada progres isi energi LV yang sesuai. Setelah pengisian penuh, Anda bisa ikutan dalam undian isi energi LV yang sesuai. Untuk detail hadiah, silakan lihat "Riwayat Hadiah" di sudut kanan atas.',
    prizesBoth: 'Hadiah untuk isi energi live streaming dan total isi energi:',
    prizeRoom: 'Progres isi energi live streaming',
    prizeStation: 'Progres total isi energi',
    avatarFrames: 'Bingkai foto profil',
    premium: 'Premium',
    winningRecords: 'Riwayat Hadiah'
  },
  blindBoxAward: {
    title: 'Riwayat Hadiah',
    stars: 'Hadiah (Star)',
    send: 'Buka',
    andWon: 'dan dapatkan',
    to: 'Untuk',
    noReward: 'Tidak ada riwayat hadiah',
  }
};

export default id;
